import * as React from 'react';

import { BorderProps, type ColorProp } from './types';

export const getBorderStyles = (
  { border, borderLeft, borderRight, borderTop, borderBottom }: BorderProps,
  color = 'divider',
  size = '1px',
  style = 'solid',
) => {
  if (!border && !borderLeft && !borderRight && !borderTop && !borderBottom) {
    return {};
  }
  return {
    border: border ? `${size} ${style}` : undefined,
    borderLeft: borderLeft ? `${size} ${style}` : undefined,
    borderRight: borderRight ? `${size} ${style}` : undefined,
    borderTop: borderTop ? `${size} ${style}` : undefined,
    borderBottom: borderBottom ? `${size} ${style}` : undefined,
    borderColor: color,
  };
};

export const findChildIndexByProp = (
  children: React.ReactNode,
  propName: string,
  propValue: any,
): number =>
  React.Children.toArray(children).findIndex(el => {
    if (!React.isValidElement(el)) return false;
    return el.props[propName] === propValue;
  });

export {
  alpha,
  debounce,
  darken,
  getLuminance,
  lighten,
  rgbToHex,
  hslToRgb,
  useMediaQuery,
  styled,
} from '@mui/material';

const validColorKeys = [
  'primary',
  'secondary',
  'error',
  'warning',
  'info',
  'success',
  'report',
  'numa',
  'customer',
  'user',
  'appointment',
  'order',
  'note',
  'task',
  'phonecall',
  'payment',
  'highlight',

  'fiveScale1',
  'fiveScale2',
  'fiveScale3',
  'fiveScale4',
  'fiveScale5',

  'tenScale1',
  'tenScale2',
  'tenScale3',
  'tenScale4',
  'tenScale5',
  'tenScale6',
  'tenScale7',
  'tenScale8',
  'tenScale9',
  'tenScale10',

  'good',
  'concern',
  'bad',

  'inherit',
];
export const isColorProp = (color?: string): color is ColorProp =>
  validColorKeys.includes(color || '');

export const isThemeColor = (
  color?: string,
): color is Exclude<ColorProp, 'default' | 'inherit'> =>
  isColorProp(color) && !['inherit'].includes(color || '');
